import { DefaultActionCacheService } from "@cervval.js/common-action/src/services/impl/default.cache.service";
import { DummyActionPersistenceService } from "@cervval.js/common-action/src/services/impl/dummy.actionPersistenceService";
import { DummyCacheService } from "@cervval.js/common-action/src/services/impl/dummy.cache.service";
import { SqlDbDefinitionMap } from "@cervval.js/common-sql-core/src/sql.common";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { DefaultTemporaryIdService } from "@cervval.js/common/src/services/temporaryIds.service";
import { ClientActionService } from "../services/client.action.service";
import { ClientActionPersistenceService } from "../services/persistence/client.actionPersistence.service";

/**
 * Will register required services for actions on client side and create a dtoCache repository for all given types
 * @param elementTypeNames list of elementType names (table names) that need to have a cache repository
 * @deprecated use registerClientActionServices
 */
export function registerClientActionService<ElementTypes>(elementTypeNames: (keyof ElementTypes)[], elementTypeTableDefinitionMap: SqlDbDefinitionMap<keyof ElementTypes, string>, options?: {
    actionCacheService?: DefaultActionCacheService<ElementTypes>
}): void {

    const actionCacheService = options?.actionCacheService ?? new DefaultActionCacheService<ElementTypes>(elementTypeTableDefinitionMap);
    actionCacheService.registerDTOCacheRepositories(elementTypeNames);
    registerClientActionServices(actionCacheService);
}

/**
 * Will register required services for actions on client side and create a dtoCache repository for all existing types
 * @returns the clientActionCacheService, you can then set 
 */
export function registerClientActionServices<ElementTypes>(actionCacheService: DefaultActionCacheService<ElementTypes>): void {
    injector.register(actionCacheService);

    injector.register(new ClientActionService());
    injector.register(new ClientActionPersistenceService(), { ignoreIfDependencyRegistered: true });// can be overriden by registering a ActionPersistenceService before
    injector.register(new DefaultTemporaryIdService(), { ignoreIfDependencyRegistered: true });// can be overriden by registering a TemporaryIdService before

}

/**
 * Will register required service to enable dummy actions
 */
export function registerDummyClientActionService(): void {

    injector.register(new DummyCacheService(new Map<never, any>()));

    injector.register(new ClientActionService());
    injector.register(new DummyActionPersistenceService(), { ignoreIfDependencyRegistered: true });// can be overriden by registering a ActionPersistenceService before
    injector.register(new DefaultTemporaryIdService(), { ignoreIfDependencyRegistered: true });// can be overriden by registering a TemporaryIdService before
}
